import { startTransition } from 'react';
import type { ErrorInfo } from 'react-dom/client';
import { hydrateRoot } from 'react-dom/client';
import { HydratedRouter } from 'react-router/dom';

import { renderingBootstrapClient } from './rendering/client/utils/renderingBootstrapClient';
import { log } from './utils/logging';

renderingBootstrapClient();

startTransition(() => {
  hydrateRoot(document, <HydratedRouter />, {
    onRecoverableError: (error: unknown, errorInfo: ErrorInfo) => {
      window.Idealist.hydrationErrors = window.Idealist.hydrationErrors ?? [];
      window.Idealist.hydrationErrors.push({
        error,
        errorInfo,
      });
      if (window.Idealist.appConstants.onHydrationError === 'log-info') {
        log.info(error);
        log.info(errorInfo);
      } else if (
        window.Idealist.appConstants.onHydrationError === 'log-error'
      ) {
        log.info(errorInfo);

        if (
          (errorInfo.componentStack?.includes('at style (<anonymous>)') ||
            errorInfo.componentStack?.includes('style@unknown:0:0')) &&
          (errorInfo.componentStack?.includes('at head (<anonymous>)') ||
            errorInfo.componentStack?.includes('head@unknown:0:0')) &&
          (errorInfo.componentStack?.includes('at html (<anonymous>)') ||
            errorInfo.componentStack?.includes('html@unknown:0:0'))
        ) {
          // oxlint-disable-next-line no-console
          console.error(
            // Mark head style hydration error separate so it can be easily excluded
            `Head Style Hydration error on ${window.location.href}`,
          );
        } else {
          // oxlint-disable-next-line no-console
          console.error(`Hydration error on ${window.location.href}`);
        }
      } else if (window.Idealist.appConstants.onHydrationError === 'throw') {
        throw error;
      }
    },
  });
});
